import contactsStore from "../store/contacts";

export default {
  modules: {
    contactsStore,
  },
};
